import React, { ChangeEvent } from 'react';
import { css } from 'styled-system/css';

import ShaojiangImage from '@shaojiang/components/ShaojiangImage';
import Tooltip from '@shaojiang/components/Tooltip';

export default function ImagesUploader() {
  const [files, setFiles] = React.useState<File[]>([]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFiles([...files, ...Array.from(e.target.files || [])]);
  };

  const removeFile = (index: number) => {
    const newFiles = Array.from(files || []);
    newFiles.splice(index, 1);
    setFiles(newFiles.length ? newFiles : []);
  };

  return (
    <div>
      {files.length > 0 && (
        <div
          className={css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            h: '80',
            '2xlDown': { h: '60' },
            lgDown: { h: '80' },
            mdDown: { h: '60' },
            smDown: { h: '80' },
            borderWidth: '1px',
            borderColor: '#E1E2E9',
            borderRadius: '3xl',
            bg: '#F9FAFF',
            _dark: { bg: 'rgb(49, 45, 75)', borderColor: 'rgba(145, 85, 253, 0.25)' },
            position: 'relative',
          })}
        >
          <ShaojiangImage
            src={URL.createObjectURL(files[0])}
            alt='upload'
            className={css({ display: 'block', maxW: 'full', maxH: 'full' })}
          />
          <ShaojiangImage
            src='/showcase/form/img-delete.svg'
            alt='delete'
            className={css({
              position: 'absolute',
              top: '2',
              right: '2',
              cursor: 'pointer',
              _hover: { opacity: 0.8 },
            })}
            onClick={() => removeFile(0)}
          />
          <ShaojiangImage
            src='/showcase/form/img-upload.svg'
            alt='upload'
            className={css({
              position: 'absolute',
              top: '2',
              right: '12',
              cursor: 'pointer',
              _hover: { opacity: 0.8 },
            })}
          />
        </div>
      )}
      {files?.length > 0 && <div className={css({ my: '4' })}>Additional Images</div>}
      <div
        className={css({
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '4',
          '2xlDown': { gridTemplateColumns: 'repeat(1, minmax(0, 1fr))' },
          lgDown: { gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' },
          smDown: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
        })}
      >
        {files &&
          files.slice(1).map((file, index) => (
            <div
              className={css({
                borderWidth: '1px',
                borderColor: '#E1E2E9',
                borderRadius: '3xl',
                bg: '#F9FAFF',
                _dark: { bg: 'rgb(49, 45, 75)', borderColor: 'rgba(145, 85, 253, 0.25)' },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                h: '40',
                position: 'relative',
              })}
              key={file.name + index}
            >
              <ShaojiangImage
                src={URL.createObjectURL(file)}
                alt='upload'
                className={css({ display: 'block', maxH: 'full', maxW: 'full' })}
              />
              <Tooltip title='Remove image'>
                <span
                  className={css({
                    position: 'absolute',
                    top: '2',
                    right: '2',
                    cursor: 'pointer',
                    _hover: { opacity: 0.8 },
                  })}
                >
                  <ShaojiangImage
                    src='/showcase/form/img-delete.svg'
                    alt='delete'
                    // `files.slice(1)` shifts indexes by one
                    onClick={() => removeFile(index + 1)}
                  />
                </span>
              </Tooltip>
              <ShaojiangImage
                src='/showcase/form/img-upload.svg'
                alt='upload'
                className={css({
                  position: 'absolute',
                  top: '2',
                  right: '12',
                  cursor: 'pointer',
                  _hover: { opacity: 0.8 },
                })}
              />
            </div>
          ))}
        <label
          htmlFor='files'
          className={css({
            _hover: { opacity: 0.8 },
            h: '40',
            borderRadius: '3xl',
            bg: '#F9FAFF',
            _dark: { bg: 'rgb(49, 45, 75)', borderColor: 'rgba(145, 85, 253, 0.25)' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            cursor: 'pointer',
            borderWidth: '1px',
            borderColor: '#E1E2E9',
          })}
        >
          <div className={css({ textAlign: 'center' })}>
            <ShaojiangImage src='/showcase/form/img-placeholder.svg' alt='upload' />
            <div
              className={css({ display: 'flex', alignItems: 'center', flexBasis: '100%', mt: '4' })}
            >
              <ShaojiangImage
                src='/showcase/form/upload.svg'
                alt='upload'
                className={css({ mr: '2' })}
              />
              <span className={css({ textStyle: 'sm' })}>Upload Images</span>
            </div>
          </div>
        </label>
      </div>
      <input
        id='files'
        type='file'
        name='files[]'
        multiple
        className={css({ display: 'none', maxW: 'full' })}
        onChange={handleChange}
        accept={'.jpg,.jpeg,.png'}
      />
    </div>
  );
}
